import formatInTimeZone from 'date-fns-tz/formatInTimeZone'
import format from 'date-fns/format'
import enUS from 'date-fns/locale/en-US'
import fr from 'date-fns/locale/fr'
import i18n from 'src/i18n'

const dateFnsLocales = { en: enUS, fr }

// Returns the active date-fns locale based on the current i18n language.
export const getDateFnsLocale = () => dateFnsLocales[i18n.language?.split('-')[0]] ?? enUS

// Override date-fns timezone format
export const formatAMPM = (date) => {
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours ? hours : 12
  minutes = minutes.toString().padStart(2, '0')
  let strTime = hours + ':' + minutes + ' ' + ampm
  return strTime
}

// const array of months
export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
export const formatDAMPM = (date) => {
  let month = getDateFnsLocale().localize.month(date.getMonth(), { width: 'abbreviated' })
  let day = date.getDate()
  day = day < 10 ? '0' + day : day
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12
  hours = hours ? hours : 12
  minutes = minutes.toString().padStart(2, '0')
  let strTime = month + ' ' + day + ' ' + hours + ':' + minutes + ' ' + ampm
  return strTime
}

export const formatWithTZ = (date, timezoneOffset = '+00:00', formatString = 'EEEE, MMM d, yyyy') => {
  let formattedDate = ''
  const locale = getDateFnsLocale()
  try {
    formattedDate = formatInTimeZone(date, timezoneOffset, formatString, { locale })
  } catch (e) {
    console.error('TZ FORMAT ERRROR:', e)
    formattedDate = format(date, formatString, { locale })
  }
  return formattedDate
}
